document.addEventListener('DOMContentLoaded', () => {
  // 1. Use querySelectorAll to find ALL buttons with the data attribute
  const openBtns = document.querySelectorAll('[data-pd-open]');
  const drawer = document.querySelector('[data-pd-drawer]');
  
  // 2. Make sure the drawer exists and we have at least one open button
  if (openBtns.length === 0 || !drawer) return;

  const closeBtns = drawer.querySelectorAll('[data-pd-close]');

  const open = () => {
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };

  const close = () => {
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
  };

  // 3. Loop through every open button and attach the click listener
  openBtns.forEach((btn) => {
    btn.addEventListener('click', open);
  });

  closeBtns.forEach((b) => b.addEventListener('click', close));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !drawer.hidden) close();
  });
});
